(() => {
  if (customElements.get('lacucu-desktop-menu')) return;
  customElements.define('lacucu-desktop-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.buttons = [...this.querySelectorAll('[data-lc-target]')];
      this.groups = [...this.querySelectorAll('.lc-menu__group')];
      this.desktop = matchMedia('(min-width: 1150px)');
      const activate = button => {
        this.buttons.forEach(item => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-expanded', String(selected));
        });
        this.groups.forEach(group => { group.hidden = group.id !== button.dataset.lcTarget; });
      };
      if (this.buttons.length) activate(this.buttons[0]);
      this.buttons.forEach(button => {
        ['click', 'mouseenter', 'focus'].forEach(event => button.addEventListener(event, () => activate(button), options));
      });
      this.position = () => {
        if (!this.desktop.matches || !this.details.open) return;
        const header = this.closest('header');
        const rect = header.getBoundingClientRect();
        const top = Math.max(8, this.trigger.getBoundingClientRect().bottom + 12);
        const left = Math.max(24, rect.left);
        this.style.setProperty('--lc-menu-top', `${top}px`);
        this.style.setProperty('--lc-menu-left', `${left}px`);
        this.style.setProperty('--lc-menu-width', `${Math.min(rect.width, innerWidth - left - 24)}px`);
        this.style.setProperty('--lc-menu-height', `${Math.max(80, innerHeight - top - 24)}px`);
      };
      this.close = (restoreFocus = false) => {
        this.details.open = false;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus && this.desktop.matches) this.trigger.focus();
      };
      this.details.addEventListener('toggle', () => {
        this.trigger.setAttribute('aria-expanded', String(this.details.open));
        this.position();
      }, options);
      document.addEventListener('click', event => {
        if (this.details.open && !this.contains(event.target)) this.close();
      }, options);
      document.addEventListener('focusin', event => {
        if (this.details.open && !this.contains(event.target)) this.close();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) { event.preventDefault(); this.close(true); }
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('a')) this.close();
      }, options);
      this.desktop.addEventListener('change', () => this.close(), options);
      window.addEventListener('resize', this.position, options);
      window.addEventListener('scroll', () => { if (this.details.open) this.close(); }, { ...options, passive: true });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();
